import { SearchRequest } from '../../providers/request/search-request.model';
import { ProjectItemType } from '../project/project-item-type.enum';

export class ArchiveFileGroupUnitSearchRequest extends SearchRequest {
  projectId?: number;
  sectionId?: number;
  sectionItemId?: number;
  sectionItemType?: ProjectItemType;
  sectionItemTypes?: Array<ProjectItemType>;
  code?: string;
  name?: string;
  sectionSectionItemId?: number;
  sectionCode?: string;
  sectionName?: string;
  segmentSectionItemId?: number;
  segmentCode?: string;
  segmentName?: string;
  partitionSectionItemId?: number;
  partitionCode?: string;
  partitionName?: string;
  isLJ?: boolean;
  fullCode?: string;
  startWithFullCode?: string;
  projectTypeCode?: string;
  projectTypeCodeChange?: boolean;
  projectTypeName?: string;
  highwayLevel?: string;
  mark?: string;
  constructionOrgName?: string;
  mileage?: string;
  appProcedure?: boolean;
  appProcedureMileage?: string;
  dwMileage?: string;
  data1?: number;
  data2?: number;
  data3?: number;
  dwSectionItemId?: number;
  dwCode?: string;
  dwName?: string;
  subDwSectionItemId?: number;
  subDwCode?: string;
  subDwName?: string;
  fbSectionItemId?: number;
  fbCode?: string;
  fbName?: string;
  fxAlias?: string;
  subFbSectionItemId?: number;
  subFbCode?: string;
  subFbName?: string;
  fxSectionItemId?: number;
  fxCode?: string;
  fxName?: string;
  sub1FxSectionItemId?: number;
  sub1FxCode?: string;
  sub1FxName?: string;
  sub2FxSectionItemId?: number;
  sub2FxCode?: string;
  sub2FxName?: string;
  sortOrder?: number;
  inRecycleBin?: boolean;
}
